<template>
	<v-dialog
		:model-value="isActive"
		persistent
		:width="width"
		class="app-confirm-dialog"
	>
		<v-card class="pa-6">
			<div class="d-flex align-center w-100">
				<span class="ao-h1">{{ titleConfirmation }}</span>
				<ao-icon-btn
					iconName="close"
					class="ml-auto"
					variant="text"
					@click="rejectDialog"
				/>
			</div>

			<p v-if="textConfirmation" class="mt-4 ao-p2-regular">{{ textConfirmation }}</p>

			<v-card-actions v-if="confirmDialogType === 'delete'"
				class="pa-0 pt-6">
				<ao-btn
					custom="softDelete"
					@click="resolveDialog"
				>
					{{ resolveButtonText }}
				</ao-btn>
				<ao-btn
					variant="text"
					@click="rejectDialog"
				>
					{{ rejectButtonText }}
				</ao-btn>
			</v-card-actions>

			<v-card-actions v-else-if="confirmDialogType === 'default'"
				class="pa-0 pt-6">
				<ao-btn
					color="primary"
					@click="resolveDialog"
				>
					{{ resolveButtonText }}
				</ao-btn>
				<ao-btn
					v-if="rejectButtonText !== null"
					variant="text"
					@click="rejectDialog"
				>
					{{ rejectButtonText }}
				</ao-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'

const props = defineProps({

	width: {
		type: Number,
		default: 428,
	},

})

const emit = defineEmits({})

const isActive = ref(false)

const titleConfirmation = ref('')
const textConfirmation = ref('')
const resolveButtonText = ref('')
const rejectButtonText = ref('')

const confirmDialogType = ref('')

const { t: $t } = useI18n()

let resolveCallback = null
// let rejectCallback = null

const open = (title, text = '', type = 'default', overriddenParams = {}) => {
	const defaultParams = {
		resolveButtonText: type === 'delete' ? $t('Delete') : $t('Yes'),
		rejectButtonText: type === 'delete' ? $t('Cancel') : $t('No'),
	}
	const params = Object.assign(defaultParams, overriddenParams)
	titleConfirmation.value = title
	textConfirmation.value = text
	confirmDialogType.value = type
	resolveButtonText.value = params.resolveButtonText
	rejectButtonText.value = params.rejectButtonText
	isActive.value = true


	return new Promise((resolve/* , reject */) => {
		resolveCallback = resolve
		// rejectCallback = reject
	})
}

const resolveDialog = () => {
	resolveCallback(true)
	resetComponentState()
}

const rejectDialog = () => {
	resolveCallback(false)
	resetComponentState()
}

const resetComponentState = () => {
	isActive.value = false
	titleConfirmation.value = null
	textConfirmation.value = null
	confirmDialogType.value = 'default'
	resolveCallback = null
}

defineExpose({
	open,
})
</script>
